/*
 * @Author: cc
 * @Date: 2020-01-08 13:23:02
 * @LastEditTime: 2022-01-11 10:43:06
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editListPart\editListPart.js
 * @Description: 采编中心列表拆分模块
 */
angular.module('editListModule', ['editListButtonsModule', 'editListListModule', 'isPassButtonModule']).controller('editListCtrl', ['$scope', function($scope) {}]);
